import { ProductGroup } from "../productGroupTypes"
import { useDateTime } from "../../../../localization/useDateTime"
import { Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

export function ProductGroupHistory({ history }: { history: ProductGroup["history"] }) {
    const dateTimeFactory = useDateTime()

    return (
        <Grid container rowGap={3}>
            <Grid container item>
                <Grid item xs={12} sm={5} justifyContent="space-between">
                    <LocalizedStrict id="history-created">
                        <Typography variant="body2">Created:</Typography>
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Typography variant="body2" textAlign="right">
                        {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(history.created?.timestamp))}
                    </Typography>
                    <Typography variant="body2" textAlign="right" fontWeight="bold">
                        {history.created?.author}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} sm={5}>
                    <LocalizedStrict id="history-edited">
                        <Typography variant="body2">Edited:</Typography>
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Typography variant="body2" textAlign="right">
                        {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(history.updated?.timestamp))}
                    </Typography>
                    <Typography variant="body2" textAlign="right" fontWeight="bold">
                        {history.updated?.author}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}
